<template>
  <div class="project w1400">
    <div class="project-header font20">
      <span>当前位置：物流项目建设 > {{childMenu[sliderTab].ts002}}</span>
      <div class="inputbox">
        <el-input placeholder="请输入内容" v-model="input7">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
    </div>
    <div class="project-cont">
          <el-row>
          <el-col :span="6">
            <div class="silder">
              <div :class="[i==sliderTab?'silder-item font20 bold':'silder-item font20']"   v-for="(item,i) in childMenu" :key='i' @click="childTab(i)">
                {{item.ts002}}
                <span class="botline" v-show='i==sliderTab'></span>
              </div>
            </div>
          </el-col>
          <el-col :span="18">
              <child :sliderTab='sliderTab' :childMenu='childMenu' :search='input7'></child>
          </el-col>
          </el-row>
    </div>
  </div>
</template>

<script>
   import child from "../common/policy.vue"
  export default {
    components:{
      child
    },
    data() {
      return {
        sliderTab:0,
        input7:'',
        childMenu:['','',''],
      }
    },
    watch:{
      '$route.path':function(){
        this.sliderTab = this.$route.params.id;
      }
    },
    created() {
      this.sliderTab = this.$route.params.id;
      this.parentId = this.$route.params.parentId;
      this.getchildMenu();
    },
    methods:{
      childTab(i){
        this.sliderTab = i;
      },
      getchildMenu(){
       this.$axios.post('/api/webMenu/getById', {
          quoteid:this.parentId
         }).then(res=>{
           let bufferArr = [];
            res.data.data.children.forEach(ele=>{
              if(ele.ts009 && ele.ts009 == 1){
                bufferArr.push(ele)
              }
            })
           this.childMenu =bufferArr;
           this.childMenu  =  this.childMenu.sort((a,b)=>{
             return a.ts007 - b.ts007;
           });
         })
      },
    }
  }
</script>

<style scoped>
  .project-header {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    height: 7rem;
    line-height: 7rem;
    padding: 0 2.7rem;
    background-color: #F6F5F5;
  }

  .inputbox {
    width: 21.6rem;
    line-height: normal;
  }

  .project-cont {
    width: 100%;
  }
  .silder{
    min-height: 94rem;
    background-color: #F6EEEE;
  }
  .silder-item{
    position: relative;
    height: 8.4rem;
    line-height: 8.4rem;
    text-align: center;
    cursor: pointer;
    background-color: #f8f8f8;
    margin-bottom: 2px;
  }
  .botline{
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 10.5rem;
    height: 3px;
    background-color: #0083CE;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/project.vue